import { useState, useEffect } from 'react';
import { API_BASE } from '../ticketConstants';
import { getSqCatalog, setSqCatalog } from '../ticketUtils';

/**
 * Loads the Square catalog once and caches at module level.
 */
export function useSquareCatalog() {
  const cached = getSqCatalog();
  const [catalog, setCatalog] = useState(() => (cached && cached.length > 0 ? cached : []));
  const [loading, setLoading] = useState(() => !(cached && cached.length > 0));

  useEffect(() => {
    const current = getSqCatalog();
    if (current && current.length > 0) {
      setCatalog(current);
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_BASE}/api/square-catalog`)
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(json => {
        const c = Array.isArray(json.catalog) && json.catalog.length > 0 ? json.catalog : [];
        if (c.length > 0) setSqCatalog(c);
        setCatalog(c);
      })
      .catch(() => setCatalog([]))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line

  return { catalog: catalog || [], loading };
}
